<template>
  <div class="v-toolbar__content">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-web</v-icon>
        </v-btn>
      </template>
      <v-card flat >
        <v-item-group>
          <v-list-item @click="setLanguage('en-EN')">EN</v-list-item>
          <v-list-item @click="setLanguage('de-DE')">DE</v-list-item>
          <v-list-item @click="setLanguage('fr-FR')">FR</v-list-item>
        </v-item-group>
      </v-card>
    </v-menu>
  </div>
</template>

<script>

export default {
  methods:{
    setLanguage(value)
    {      
      this.$store.dispatch('i18n/setLanguage',{lang:value, clientid:this.$store.state.client_id })      
    }
  }
};
</script>

<style>
</style>